// Fit rendered SVG geometry, including disconnected targets and their labels.
// The key/size guard leaves subsequent user pan and zoom gestures alone.
export function fitHighlightedChart(instance, state, key) {
    const svg = instance?.getDom().querySelector('svg');
    if (!svg) return;
    const viewport = svg.getBoundingClientRect();
    if (!viewport.width || !viewport.height) return;
    if (state.key !== key || state.instance !== instance) state.frozen = false;
    if (state.key !== key || state.instance !== instance || state.width !== viewport.width || state.height !== viewport.height) {
        Object.assign(state, { key, instance, width: viewport.width, height: viewport.height, passes: 0 });
    }
    if (!state.frozen) {
        state.frozen = true;
        // Snapshot the completed ECharts force layout into draggable explicit coordinates.
        // Leaving the force nodes fixed would prevent drag updates in this ECharts version.
        const data = instance.getModel().getSeriesByIndex(0).getData();
        const nodes = instance.getOption().series[0].data.map((node, index) => {
            const position = data.getItemLayout(index);
            return { ...node, x: position[0], y: position[1] };
        });
        instance.setOption({ series: [{ layout: 'none', data: nodes }] }, { silent: true });
        return;
    }
    if (state.passes >= 3) return;
    const boxes = Array.from(svg.querySelectorAll('path,text')).map(element => element.getBoundingClientRect()).filter(box => box.width || box.height);
    if (!boxes.length) return;
    const left = Math.min(...boxes.map(box => box.left)), right = Math.max(...boxes.map(box => box.right));
    const top = Math.min(...boxes.map(box => box.top)), bottom = Math.max(...boxes.map(box => box.bottom));
    const zoom = Math.min(1, (viewport.width - 48) / Math.max(1, right - left), (viewport.height - 48) / Math.max(1, bottom - top));
    const dx = viewport.left + viewport.width / 2 - (left + right) / 2, dy = viewport.top + viewport.height / 2 - (top + bottom) / 2;
    if (zoom > 0.99 && Math.abs(dx) < 2 && Math.abs(dy) < 2) { state.passes = 3; return; }
    state.passes += 1;
    const center = instance.convertFromPixel({ seriesIndex: 0 }, [(left + right) / 2 - viewport.left, (top + bottom) / 2 - viewport.top]);
    instance.setOption({ series: [{ center, zoom: instance.getOption().series[0].zoom * Math.max(0.05, zoom) }] }, { silent: true });
}
